const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const PriceRow = ({ label, prix }) => (
    <li
        className="flex items-baseline justify-between gap-4 border-b py-2.5 last:border-0"
        style={{ borderColor: "var(--c-line)" }}
        data-testid={`tarif-ligne-${slug(label)}`}
    >
        <span>{label}</span>
        <span className="whitespace-nowrap font-bold text-terrat">{prix}</span>
    </li>
);

export const PriceCard = ({ titre, lignes, split = false }) => (
    <div
        className="card card-motif mb-6 break-inside-avoid p-6"
        data-testid={`tarif-carte-${slug(titre)}`}
    >
        <h3 className="text-lg font-bold text-olivet">{titre}</h3>
        <hr className="rule-gold mt-3 w-12" />
        <ul className={`mt-2 ${split ? "sm:columns-2 sm:gap-x-10" : ""}`}>
            {lignes.map(([label, prix]) => (
                <PriceRow key={label} label={label} prix={prix} />
            ))}
        </ul>
    </div>
);
